// Cliente da rota do PAINEL DA REDE (a Home). Molde: relatorio.service.ts.
//
// SOMENTE LEITURA. Os tipos são o espelho de
// `alfredo-central-backend/src/services/painel/rede.service.ts` — mudou lá,
// muda aqui. Não há pacote compartilhado entre os dois repos (a mesma razão
// registrada em `common/subsidiaryInfo.enum.ts`, que também existe duas vezes).
import api from "./api.service";

export interface NumerosDaUnidade {
  /** Dinheiro chega como STRING. Formatar na tela, nunca converter no meio. */
  receitaLiquida: string;
  receitaBruta: string;
  descontos: string;
  pedidos: number;
  pessoas: number;
  ticket: string | null;
}

export type AtribuicaoDoNumero = "unidade" | "rede" | "semOperacao";

export interface UnidadeDoPainel {
  uuid: string;
  nome: string;
  companyUuid: string;
  companyNome: string;
  endereco: string | null;
  telefone: string | null;
  whatsapp: string | null;
  lat: number | null;
  lng: number | null;
  coordenadaConferida: boolean;
  aceitaPedido: boolean;
  operaNoOps: boolean;
  numeros: NumerosDaUnidade | null;
  atribuicao: AtribuicaoDoNumero;
}

export interface CompanyDoPainel {
  uuid: string;
  nome: string;
  unidades: UnidadeDoPainel[];
}

export interface AvisoDoPainel {
  codigo: string;
  texto: string;
  colunas?: string[];
}

export interface PainelDaRede {
  organizacao: { uuid: string; nome: string } | null;
  companies: CompanyDoPainel[];
  periodo: { de: string; ate: string };
  totalDaRede: NumerosDaUnidade;
  avisos: AvisoDoPainel[];
  fonte: { cadastro: string; operacao: string; observacao: string };
}

class PainelClass {
  async rede(filtro: { de?: string; ate?: string } = {}): Promise<PainelDaRede> {
    const parametros = new URLSearchParams();
    if (filtro.de) parametros.set("de", filtro.de);
    if (filtro.ate) parametros.set("ate", filtro.ate);
    const query = parametros.toString();
    const resposta = await api.get(`/painel/rede${query ? `?${query}` : ""}`);
    return resposta.data;
  }
}

const painelService = new PainelClass();
export default painelService;

/** Achata a árvore em uma lista de unidades — é o que o mapa e a lista querem. */
export function unidadesDoPainel(painel: PainelDaRede | null): UnidadeDoPainel[] {
  if (!painel) return [];
  return painel.companies.flatMap((company) => company.unidades);
}

/** `"1234.50"` -> `"R$ 1.234,50"`. Formata a STRING, sem passar por Number. */
export function comoDinheiro(valor: string | null | undefined): string {
  if (valor == null || valor === "") return "—";
  const numero = Number(valor);
  if (!Number.isFinite(numero)) return "—";
  return numero.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}
